import {
  postReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  exportExcelReq,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  searchInfo: {
    searchMonth: Utils.getMonthFirstDay(new Date()) // 2019-10-01
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())]
    // startDt: null,
    // endDt: null
  },
  fundStatInfo: {
    rptMonth: new Date(0),
    settleDt: new Date(0),
    projMgr: '',
    rptEditor: '',
    rptStatus: '',
    finishBy: '',
    finishOn: new Date(0),
    priFundStatAcctList: [],
    sndFundStatAcctList: [],
    pmFundStatAcctList: [],
    fundStatOthVO: null
  },
  fundStatAcctDDList: [],
  editIndex: -1,
  editEntityId: '',
  editEntityType: '',
  editIncomeType: '',
  editPaymentType: '',
  editCtrAcctId: '',
  editCheckedAmt: 0,
  editRemarks: '',
  // editAction: '',
  // indEdit: 'N',
  END_STATE: null
}

const getters = {
  END_GETTERS() {}
}

const actions = {
  async updateReportInfo({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam, searchMonth}) {
    // console.log(transId)
    let rptMth = Utils.formatDateToMonthNum(searchMonth)
    // debugger
    let fundStatInfo = {
      settleDt: state.fundStatInfo.settleDt,
      projMgr: state.fundStatInfo.projMgr,
      rptEditor: state.fundStatInfo.rptEditor,
      //
      key: {
        rptMth: rptMth,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await postReq(END_POINTS.UPDATE_FUND_STAT_INFO, {
      data: fundStatInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async findFundStatAcctDDList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    // rptMth = new Date(rptMth).getTime()
    // endDt = new Date(endDt).getTime()
    const response = await postReq(END_POINTS.FIND_FUND_STAT_ACCT_DD_LIST, {
      data: {
        projId: projId,
        compId: compId
        // ,
        // rptMth: rptMth
        // ,
        // endDt: endDt
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateFundStatAcctDDList', response)
  },
  async findFundStat({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam, rptMth }) {
    rptMth = new Date(rptMth).getTime()
    // endDt = new Date(endDt).getTime()
    const response = await postReq(END_POINTS.FIND_FUND_STAT, {
      data: {
        projId: projId,
        compId: compId,
        searchMonth: rptMth
        // ,
        // endDt: endDt
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateFundStatInfo', response)
  },
  async updateFundStatEntity({
    commit,
    state,
    rootState
  }, {rptEntityId, rptMth, projId, compId, refId, entityName, codeParam}) {
    // startDt = new Date(startDt).getTime()
    // endDt = new Date(endDt).getTime()
    // debugger
    const response = await postReq(END_POINTS.UPDATE_FUND_STAT_ENTITY, {
      data: {
        // entityId: entityId,
        entityName: entityName,
        checkedAmt: state.editCheckedAmt || 0,
        remarks: state.editRemarks,
        //
        rptEntityId: rptEntityId,
        rptMth: rptMth,
        projId: projId,
        compId: compId,
        entityId: state.editEntityId,
        entityType: state.editEntityType,
        incomeType: state.editIncomeType,
        paymentType: state.editPaymentType,
        ctrAcctId: state.editCtrAcctId,
        refId: refId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return response
    // commit('updateFundStatInfo', response)
  },
  async downloadFundStat({
    commit,
    state,
    rootState
  }, { projId, compId, rptMth, codeParam }) {
    rptMth = new Date(rptMth).getTime()
    // endDt = new Date(endDt).getTime()
    const response = await exportExcelReq(END_POINTS.DOWNLOAD_FUND_STAT, {
      data: {
        projId: projId,
        compId: compId,
        searchMonth: rptMth
        // ,
        // endDt: endDt
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    // commit('updateFundStatInfo', response)
    return response
  },
  END_ACTIONS() {}
}

const mutations = {
  updateSearchMonth(state, value) {
    state.searchInfo.searchMonth = value
  },
  // fundStatInfo
  updateSettleDt(state, value) {
    state.fundStatInfo.settleDt = value
  },
  updateProjMgr(state, value) {
    state.fundStatInfo.projMgr = value
  },
  updateRptEditor(state, value) {
    state.fundStatInfo.rptEditor = value
  },
  updateRptStatus(state, value) {
    state.fundStatInfo.rptStatus = value
  },
  // enableEditPanel() {
  //   state.indEdit = 'Y'
  // },
  disableEditPanel() {
    // state.indEdit = 'N'
    state.editIndex = -1
    state.editEntityId = ''
    state.editEntityType = ''
    state.editIncomeType = ''
    state.editPaymentType = ''
    state.editCtrAcctId = ''
    state.editCheckedAmt = 0
    state.editRemarks = ''
  },
  updateEditIndex(state, value) {
    state.editIndex = value
  },
  updateEditEntityId(state, value) {
    state.editEntityId = value
  },
  updateEditEntityType(state, value) {
    state.editEntityType = value
  },
  updateEditIncomeType(state, value) {
    state.editIncomeType = value
  },
  updateEditPaymentType(state, value) {
    state.editPaymentType = value
  },
  updateEditCtrAcctId(state, value) {
    state.editCtrAcctId = value
  },
  updateEditCheckedAmt(state, value) {
    state.editCheckedAmt = value
  },
  updateEditRemarks(state, value) {
    state.editRemarks = value
  },
  updateFundStatAcctDDList(state, response) {
    if (response.success) {
      state.fundStatAcctDDList = response.data
    } else {
      state.fundStatAcctDDList = []
    }
  },
  updateFundStatInfo(state, response) {
    if (response.success) {
      state.fundStatInfo = response.data
    } else {
      state.fundStatInfo = {
        rptMonth: new Date(0),
        settleDt: new Date(0),
        projMgr: '',
        rptEditor: '',
        rptStatus: '',
        finishBy: '',
        finishOn: new Date(0),
        priFundStatAcctList: [],
        sndFundStatAcctList: [],
        pmFundStatAcctList: [],
        fundStatOthVO: null
      }
    }
  },
  updateFundStatInfoEmpty(state) {
    state.fundStatInfo = {
      rptMonth: new Date(0),
      settleDt: new Date(0),
      projMgr: '',
      rptEditor: '',
      rptStatus: '',
      finishBy: '',
      finishOn: new Date(0),
      priFundStatAcctList: [],
      sndFundStatAcctList: [],
      pmFundStatAcctList: [],
      fundStatOthVO: null
    }
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/fundStatManage.js